export const defaultFormatChars={9:"[0-9]",a:"[A-Za-z]",A:"[A-Z]","*":"[A-Za-z0-9]","&":"[0-9A-Z]"};export const maskPlaceholderChar="_";